export default __webpack_public_path__ + "353cf315ec59c4890641df52698ffca9.svg";